import { IQuestionModel } from '@care-portals/api-interfaces';

const prepQuestion: IQuestionModel[] = [
  /**
   * Prep Forms
   */
  {
    label: 'Prep Consultation',
    educationalSlide:
      'In order to best assess your needs and eligibility for this treatment, we have to ask some personal questions that may involve sensitive subject matter. Please be assured that Jack Health abides by the PHIPA Act (Personal Health Information Protection Act), so all information you give us is kept strictly confidential.',
    field: 'prep_disclosure',
    type: 'info',
    answer: {}
  },
  {
    label: 'Have you been diagnosed with HIV?',
    field: 'prep_hiv',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: 'Have you taken PrEP before?',
    field: 'prep_before',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: 'Are you currently on PrEP, or have you been on PrEP previously?',
    field: 'prep_currentBefore',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no_firstTime', value: 'No, this will be my first time' },
        { key: 'yes_currently', value: 'Yes, I am currently on PrEP' },
        { key: 'yes_previously', value: 'Yes, have been previously on it' }
      ]
    }
  },
  {
    label: 'Which drug and how long have you been on it for?',
    subLabel:
      'If you would like us to transfer your prescription from your existing pharmacy, please enter the pharmacy details here (name, address and phone number).',
    field: 'prep_drug_current',
    type: 'info',
    answer: {
      type: 'text'
    }
  },
  {
    label:
      'Please provide details including which one, how long you were on it, and when',
    field: 'prep_drug_previous',
    type: 'info',
    answer: {
      type: 'text'
    }
  },
  {
    label:
      'How many partners have you had penetrative anal intercourse with in the past 6 months',
    field: 'prep_partners',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'zero', value: '0' },
        { key: 'one', value: '1' },
        { key: 'two_four', value: '2-4' },
        { key: 'five_plus', value: '5+' }
      ]
    }
  },
  {
    label:
      'Do you know the HIV status of all of your current or ongoing sexual partners?',
    field: 'prep_partnersHIV',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_all_negative',
          value: 'Yes – all of them are HIV negative'
        },
        {
          key: 'yes_at_least_one_positive',
          value: 'Yes – at least one of them is HIV positive'
        },
        {
          key: 'no_dont_know',
          value: 'No – I do not know the HIV status of all of them'
        }
      ]
    }
  },
  {
    label:
      'In the last 6 months, how many times did you have condomless receptive anal intercourse (you were on bottom)?',
    field: 'prep_receptive',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'zero', value: '0' },
        { key: 'one_five', value: '1-5' },
        { key: 'five_ten', value: '5-10' },
        { key: 'ten_plus', value: '10+' }
      ]
    }
  },
  {
    label:
      'In the last 6 months, how many times did you have insertive anal intercourse (you were on top)?',
    field: 'prep_insertive',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'zero', value: '0' },
        { key: 'one_five', value: '1-5' },
        { key: 'five_ten', value: '5-10' },
        { key: 'ten_plus', value: '10+' }
      ]
    }
  },
  {
    label:
      'In the last 6 months, have you used methamphetamines such as crystal or speed?',
    field: 'prep_meth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label: 'In the last 6 months, have you used poppers (amyl nitrate)?',
    field: 'prep_poppers',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you ever been diagnosed with any of the following medical conditions (select all that apply):',
    field: 'prep_medicalConditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hepatitis_c', value: 'Hepatitis C' },
        { key: 'hepatitis_b', value: 'Hepatitis B' },
        { key: 'diabetes', value: 'Diabetes' },
        { key: 'liver_disease', value: 'Liver Disease' },
        { key: 'kidney_disease', value: 'Kidney Disease' },
        { key: 'syphilis', value: 'Syphilis' },
        { key: 'gonorrhea', value: 'Gonorrhea' },
        { key: 'chlamydia', value: 'Chlamydia' },
        { key: 'none', uncheckOthers: true, value: 'None of the above' }
      ]
    }
  },
  {
    label: 'In the past 4-6 weeks, have you experienced any flu like symptoms?',
    field: 'prep_fluLikeSymptoms',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label:
      'PrEP can affect bone density.  In order to help identify your bone health risk, please select all that apply:',
    field: 'prep_boneHealthRisk',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'older_than_50', value: 'I am 50 years or older' },
        {
          key: 'broken_bone',
          value: 'I have ever broken a bone from a minor fall or accident'
        },
        {
          key: 'parent_broken_hip',
          value: 'One of my parents has broken a hip'
        },
        { key: 'smoke', value: 'I smoke cigarettes' },
        { key: 'drink', value: 'I drink 3 or more alcoholic drinks most days' },
        {
          key: 'steroids',
          value:
            'I have taken long-term steroids (like prednisone for 3 months or longer)'
        },
        {
          key: 'arthritis',
          value:
            'I have rheumatoid arthritis, HIV, hepatitis B/C, or another chronic illness affecting bones'
        },
        { key: 'low_weight', value: 'I have a very low body weight (BMI <20)' },
        { key: 'none', uncheckOthers: true, value: 'None of the above' }
      ]
    }
  },
  {
    label:
      'Are you currently taking, or do you plan to take, any of the following medications? (select all that apply)',
    field: 'prep_medications',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'nsaid',
          value:
            'Long-term or high-dose NSAIDs (ibuprofen, naproxen, diclofenac, indomethacin)'
        },
        {
          key: 'antibiotic',
          value:
            'Antibiotics or antifungals that affect the kidneys (gentamicin, tobramycin, amikacin, amphotericin B, adefovir, cidofovir, ganciclovir, valganciclovir)'
        },
        {
          key: 'antiviral',
          value:
            'Antiviral drugs for hepatitis C (ledipasvir/sofosbuvir or other DAA treatments)'
        },

        {
          key: 'anticonvulsant',
          value:
            'Anticonvulsants (carbamazepine, oxcarbazepine, phenobarbital, phenytoin)'
        },

        {
          key: 'tb_medications',
          value: 'TB medications (rifampin, rifabutin, rifapentine)'
        },

        {
          key: 'probenecid',
          value: 'Probenecid (for gout or to boost some antibiotics)'
        },

        {
          key: 'other_hiv_medications',
          value:
            'Other HIV medications (protease inhibitors, cobicistat, ritonavir)'
        },

        { key: 'none', uncheckOthers: true, value: 'None of the above' }
      ]
    }
  },
  {
    label:
      'Unfortunately PrEP is a preventative HIV medication, and cannot be taken by those already affected. We recommend going to your local HIV clinic, which can provide many different types of healthcare such as pediatric, psychiatric, and counselling, as well as providing more information.',
    class: 'ineligible',
    field: 'prep_ineligible',
    isLast: true,
    type: 'info',
    answer: {}
  },
  {
    field: 'prep_complete',
    label:
      'Thank you for answering the questions, we really appreciate your time and effort. Your results show that you may be a candidate for PrEP with Jack Health. One of our practioners will review your responses, and contact you with a lab requisition if required.',
    subLabel: 'Please select "Finish" to submit',
    isLast: true,
    type: 'info',
    answer: {}
  }
];

export default prepQuestion;
